import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { href: '/', label: '首页' },
    { href: '/category/character-background', label: '角色背景' },
    { href: '/category/skill-system', label: '技能体系' },
    { href: '/category/combo-guide', label: '连招攻略' },
    { href: '/category/cultural-impact', label: '文化影响' },
    { href: '/category/character-ranking', label: '角色排行' },
  ],
  about: [
    { href: '/about', label: '关于我们' },
    { href: '/about#contact', label: '联系我们' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50">
                拳皇档案馆
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              拳皇档案馆致力于为格斗游戏爱好者提供最全面、最专业的不知火舞角色攻略与深度解析内容。
              从角色背景到实战连招，从文化影响到排行分析，一站式满足您对不知火舞的所有好奇。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              内容导航
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.navigation.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
              关于本站
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-accent-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 拳皇档案馆. All rights reserved. 本站为粉丝自制内容站点，与SNK Corporation无关联。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors"
              aria-label="Bilibili"
              rel="nofollow"
            >
              <i className="ri-bilibili-line"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-accent-400 hover:bg-background-700 transition-colors"
              aria-label="GitHub"
              rel="nofollow"
            >
              <i className="ri-github-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}